import { EmergingMarket } from '@/creditflowresearch/domain/Market';
import type { ISubscriptionAdapter } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters/types';
import { filterAndGroupThemes, buildBaseFilterGroups } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/helpers';
import { restrictToSubscribableRegions } from '@/creditflowresearch/application/ArticlesAndStats/ArticlesSubscriptions/helpers';

export const emAdapter: ISubscriptionAdapter = {
  shouldUse: (context) =>
    context.currentMarket instanceof EmergingMarket,

  filterThemes: (context) => {
    if (!context.currentMarket) {
      return { groupedThemes: {}, themesIds: {} };
    }

    const currentMarketId = context.currentMarket.getId();

    return filterAndGroupThemes(
      context.themes,
      ({ marketId, regionId }) => marketId === currentMarketId
                                 && context.subscribableRegionIds.includes(regionId),
    );
  },

  getRegionIds: (context) => {
    if (!context.currentMarket) {
      return [];
    }

    const currentMarketId = context.currentMarket.getId();
    const emThemes = context.themes.filter(({ marketId }) => marketId === currentMarketId);
    const uniqueRegionIds = [...new Set(emThemes.map(({ regionId }) => regionId))];

    return restrictToSubscribableRegions(uniqueRegionIds, context.subscribableRegionIds);
  },

  getModalTitle: (context) =>
    `${ context.currentMarket?.getDisplayName() || '' } Email Alerts`,

  shouldFilterByProduct: false,

  buildFilterGroups: (groupedThemes, themesIds, context) =>
    buildBaseFilterGroups(
      groupedThemes,
      themesIds,
      (articleTypeTitle) => `All ${ context.currentMarket?.getDisplayName() || '' } ${ articleTypeTitle }`,
    ),
};
